"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.company.demonstrations")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.company.demonstrationsRedirect", {
            url: "/demonstracoes-redirect?scenarioId",
            params: {
                scenarioId: { value: null, dynamic: true }
            },
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-demonstrations" */ "./demonstrations.entry"
                ).then(() =>
                    Promise.all([
                        $ocLazyLoad.inject("nucont.accounting.company.demonstrations"),
                        $ocLazyLoad.inject("nucont.accounting.company.showtime")
                    ])
                );
            },
            views: {
                "admin@nucont.accounting": {
                    component: "demonstrationsRedirectComponent",
                    bindings: { companyData: "CompanyData" }
                }
            }
        })
        .state("nucont.accounting.company.demonstrations", {
            views: {
                "admin@nucont.accounting": {
                    component: "demonstrationsComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-demonstrations" */ "./demonstrations.entry"
                ).then(() =>
                    Promise.all([
                        $ocLazyLoad.inject("nucont.accounting.company.demonstrations"),
                        $ocLazyLoad.inject("nucont.accounting.company.showtime")
                    ])
                );
            }
        });
}
